import React, { createContext, useContext, useState, useEffect } from 'react';
import { profileAPI, scheduleProactiveRefresh } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const AUTH_PAGES = ['/login', '/signup', '/mfa-verify', '/mfa-setup', '/reset-password', '/reset-password-verify', '/verify-email', '/pending', '/oauth/callback'];
    if (AUTH_PAGES.some(p => window.location.pathname.startsWith(p))) {
      setLoading(false);
      return;
    }
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      const data = await profileAPI.getProfile();
      if (data.status === 'success') {
        setUser(data.user);
        scheduleProactiveRefresh();
      }
    } catch (err) {
      // Not authenticated or session expired
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const refreshProfile = async () => {
    try {
      const data = await profileAPI.getProfile();
      if (data.status === 'success') {
        setUser(data.user);
      }
    } catch (err) {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, refreshProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
